import { render, staticRenderFns } from "./EditTagsModalV2.vue?vue&type=template&id=e83cab22&scoped=true"
import script from "./EditTagsModalV2.vue?vue&type=script&lang=js"
export * from "./EditTagsModalV2.vue?vue&type=script&lang=js"
import style0 from "./EditTagsModalV2.vue?vue&type=style&index=0&id=e83cab22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83cab22",
  null
  
)

export default component.exports